<template>
    <div class="currency-select" v-if="selectedCurrency && selectedCurrency.name">
        <form id="currency-form" class="styled-dropdown">
            <div class="btn-group">
                <button data-toggle="dropdown" class="dropdown-toggle">
                    {{ selectedCurrency.symbol }}
                    <span class="sr-only">{{ selectedCurrency.name }}</span>
                    <span class="caret"></span>
                    <i class="fa fa-fw fa-chevron-down float-right"></i>
                    <i class="fa fa-fw fa-chevron-up float-right"></i>
                </button>
                <ul class="dropdown-menu">
                    <li class="clearfix" v-for="currency in currencies" :key="currency.name" @click="selectCurrency(currency)" data-dismiss="modal">
                        <label
                            ><span class="currency-icon">{{ currency.symbol }}</span> {{ currency.name }}</label
                        >
                    </li>
                </ul>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import lang from '../../shared/mixins/lang';

import SelectCurrency from 'greenmotion-shared/mixins/selectCurrency';

export default {
    mixins: [lang, SelectCurrency],
    computed: Object.assign(
        {},
        mapGetters({
            currencies: 'getCurrencies',
            selectedCurrency: 'selectedCurrency',
        })
    ),
    mounted() {
        // A currency picked by another app on the page (e.g. the quote's converted currency
        // for new users) reaches this component's store via currencySyncPlugin.
        this.$store.dispatch('fetchCurrencies');
    },
};
</script>

<style lang="scss" scoped>
#currency-form .dropdown-toggle[aria-expanded='true'] .fa-chevron-down,
#currency-form .fa-chevron-up,
#currency-form .fa-chevron-down {
    display: none;
}
</style>
